import { createAction, props } from '@ngrx/store';
import { Datopelicula } from 'src/app/models/pelicula.model';


export const setPeliculas = createAction(
  '[Peliculas Publicadas] carga películas publicadas',
  props<{ peliculas: Datopelicula[]}>()
  );
export const unSetPeliculas = createAction('[Peliculas Publicadas] descarga películas publicadas');
